import React, { ComponentProps } from 'react';

import { TrackedLink } from 'components/Link';

import { PrimaryButton } from './PrimaryButton';

export function TrackedPrimaryButtonLink(
  props: ComponentProps<typeof PrimaryButton>
) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <PrimaryButton component={TrackedLink} type={undefined} {...props} />;
}
